import { UserTag } from './UserTag';

class UserRoles {
    constructor() {
        this.roles = new Map();
        this.roles.set('user', 1);
        this.roles.set('admin', 3);
        this.roles.set('dj', 5);
        this.roles.set('emcee', 7);
        this.roles.set('party_host', 11);
        this.roles.set('party_guest', 13);
    }
}

export class UserData {
    constructor(data) {
        this.data_name = data.data_name;
        this.data_value = data.data_value;
    }
}

export class User {

    constructor(user) {
        this.uuid = user.uuid;
        this.name = user.name;
        this.roles_value = user.roles_value;
        this.role_names = user.role_names;
        this.data = user.data
        this.tags = user.tags;
        this.lists = user.lists;
    }

    hasRole(roleName) {
        const ur = new UserRoles();
        if(ur.roles.has(roleName)) {
            // console.log(`user ${this.name} role value ${this.roles_value}`);
            // console.log(`role ${roleName} value ${ur.roles.get(roleName)}`);
            return(this.roles_value % ur.roles.get(roleName) == 0);
        } else {
            throw(`${roleName} is not a valid role`);
        }

    }

    grantRole(roleName) {
        const ur = new UserRoles();
        if (! this.hasRole(roleName)) {
            this.roles_value = this.roles_value * ur.roles.get(roleName);
        }
    }

    revokeRole(roleName) {
        const ur = new UserRoles();
        if (this.hasRole(roleName)) {
            this.roles_value = this.roles_value / ur.roles.get(roleName);
        }
    }
}